import React from "react";
import { NavLink } from "react-router-dom";
import { IoCall } from "react-icons/io5";

const Top = () => (
  <div className="bg-teal-800 text-white">
    <div className="mx-auto flex min-h-[44px] max-w-7xl items-center justify-between gap-4 px-5 py-2 text-sm lg:px-8">
      <a href="tel:+918796040788" className="flex items-center gap-2 rounded-sm font-medium hover:text-teal-100 focus:outline-none focus-visible:ring-2 focus-visible:ring-white">
        <IoCall aria-hidden="true" />
        <span className="hidden sm:inline">Need help? Call us:</span>
        <span>+91 87960 40788</span>
      </a>
      <div className="hidden items-center gap-3 md:flex" aria-label="Utility navigation">
        <NavLink className="utility-link" to="/blog">Digital Diary</NavLink>
        <span className="text-teal-300" aria-hidden="true">|</span>
        <NavLink className="utility-link" to="/contact">Contact Us</NavLink>
        <span className="text-teal-300" aria-hidden="true">|</span>
        <a className="utility-link" href="mailto:careers@lumetrasoftech.in">Career</a>
      </div>
    </div>
  </div>
);

export default Top;
